// ** Redux Imports
import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'

// ** Axios Imports
import axios from 'axios'

export const getAllDataNetconfigsSite = createAsyncThunk('appUsers/getAllDataNetconfigsSite', async id => {
  const response = await axios.get('https://apiv3dev.opentlv.com/api/v3/zone/netconfigs/all',  { params: { id} })
  return response.data
})

export const getDataNetconfigsSite = createAsyncThunk('appUsers/getDataNetconfigsSite', async params => {
  const response = await axios.get('https://apiv3dev.opentlv.com/api/v3/zone/netconfigs/data', {params})
  return {
    params,
    data: response.data.data,
    totalPages: response.data.total
  }
})

export const getUser = createAsyncThunk('appUsers/getUser', async id => {
  const response = await axios.get('https://apiv3dev.opentlv.com/api/v3/users/user', { params: { id} })
  console.log(response.data)
  return response.data
})

export const addUser = createAsyncThunk('appUsers/addUser', async (user, { dispatch, getState }) => {
  await axios.post('/apps/users/add-user', user)
  await dispatch(getData(getState().users.params))
  await dispatch(getAllData())
  return user
})

export const deleteUser = createAsyncThunk('appUsers/deleteUser', async (id, { dispatch, getState }) => {
  await axios.delete('/apps/users/delete', { id })
  await dispatch(getData(getState().users.params))
  await dispatch(getAllData())
  return id
})
export const addNetconfigToZone = createAsyncThunk('appUsers/addNetconfigToZone', async (option, { dispatch, getState }) => {
  //  option.client_id = getState()
    console.log("add Channel to Zone")
    console.log(getState().zoneChannels)
    option.zone_id = getState().zoneChannels.selectedZone.id
  
     await axios.post('https://apiv3dev.opentlv.com/api/v3/zone/addnetconfigtozone', option)

      await dispatch(getDataNetconfigsSite(getState().zoneChannels.params))
  
    //await d
  })
export const appClientsSlice = createSlice({
  name: 'appUsers',
  initialState: {
    data: [],
    total: 1,
    params: {},
    allData: [],
    selectedUser: null
  },
  reducers: {},
  extraReducers: builder => {
    builder
      .addCase(getAllDataNetconfigsSite.fulfilled, (state, action) => {
        state.allData = action.payload
      })
      .addCase(getDataNetconfigsSite.fulfilled, (state, action) => {
        state.data = action.payload.data
        state.params = action.payload.params
        state.total = action.payload.totalPages
      })
      .addCase(getUser.fulfilled, (state, action) => {
        state.selectedUser = action.payload
      })
  }
})

export default appClientsSlice.reducer
